<template>
    <Form
        :form="form"
        :model="model"
    />
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>